import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  EventEmitter,
  HostListener,
  inject,
  input,
  InputSignal,
  Output
} from '@angular/core';

const BODY_LOCK_CLASS: string = 'sz-body-scroll-lock';

@Component({
  selector: 'sz-bottom-sheet',
  templateUrl: './sz-bottom-sheet.component.html',
  styleUrls: ['./sz-bottom-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzBottomSheetComponent {
  readonly open: InputSignal<boolean> = input<boolean>(false);
  readonly dismissOnScrim: InputSignal<boolean> = input<boolean>(true);
  readonly dismissOnEsc: InputSignal<boolean> = input<boolean>(true);

  @Output() readonly close: EventEmitter<void> = new EventEmitter<void>();

  private readonly document: Document = inject(DOCUMENT);

  constructor() {
    effect((): void => {
      const isOpen: boolean = this.open();
      this.document.body.classList.toggle(BODY_LOCK_CLASS, isOpen);
    });
  }

  onScrimClick(): void {
    if (this.dismissOnScrim()) {
      this.close.emit();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open() && this.dismissOnEsc()) {
      this.close.emit();
    }
  }
}
